import authInstance from "../Interceptor/interceptor";

export const addAdmissionEffect = (formData) => {
  return authInstance.post("/admissions/insertadmission", formData);
};

export const deleteAdmissionEffect = (id) => {
  return authInstance.delete(`/admissions/deleteadmission/${id}`);
};

export const editAdmissionEffect = (id, formData) => {
  return authInstance.put(
    `/admissions/dischargeadmission/${formData.admissionId}`,
    formData.admissionData
  );
};

export const ViewAdmissionEffect = (id) => {
  return authInstance.get(
    `/admissions/getadmissionbypatient?patient_id=${id}&admission_status=1`
  );
};
export const listAdmissionEffect = (payload) => {
  const { 
    pageNo, 
    pagesize, 
    pagination_required, 
    search, 
    start_date, 
    end_date, 
    ward_id, 
    floor_id, 
    block_id,
    ip_number,
    patient_name,
    phone 
  } = payload;

  let url = `/admissions/getadmissionslist?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}`;

  if (start_date) url += `&start_date=${start_date}`;
  if (end_date) url += `&end_date=${end_date}`;
  if (ward_id) url += `&ward_id=${ward_id}`;
  if (floor_id) url += `&floor_id=${floor_id}`;
  if (block_id) url += `&block_id=${block_id}`;
  if (search) url += `&search=${search}`;
  if (ip_number) url += `&ip_number=${ip_number}`;
  if (patient_name) url += `&patient_name=${patient_name}`;
  if (phone) url += `&phone=${phone}`;

  return authInstance.get(url);
};

export const ViewAdmissionPatientEffect = (id) => {
  return authInstance.get(`/admissions/getAdmission?admission_id=${id}`);
};
export const listReportEffect = (payload) => {
  const { pageNo, pagesize, pagination_required, search_by, start_date, end_date } = payload;
  const url = `/admissions/reportlist?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}&search=${search_by}&start_date=${start_date}&end_date=${end_date}`;
  return authInstance.get(url);
};

export const listAdmission = (pageNo) => {
  return authInstance.get(
    `/admissions/admissionlist?pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};

export const listAdmissionAll = (pageNo) => {
  return authInstance.get(
    `/admissions/list?pageNo=${pageNo}&pagesize=10&pagination_required=false`
  );
};

export const listAdmissionByPhoneNumber = (phoneNumber) => {
  return authInstance.get(`/admissions/getadmissionbyphone?phone=${phoneNumber}`);
};

export const updateAdmissionEffect = (id, formData) => {
  return authInstance.put(
    `/admissions/updateadmission/${id}`,
    formData
  );
};

export const admissionParticularEffect = (admissionId) => {
  return authInstance.get(`/admissions/getAdmission?admission_id=${admissionId}`);
};

export const bulkDischargeEffect = (formData) => {
  return authInstance.post("/admissions/bulk-discharge", formData);
};
